import apiClient from './api';
import { RepoData, CommitStatus } from '@app-types/types';

export const getRepoData = async (): Promise<RepoData> => {
  const response = await apiClient.get<RepoData>('/api/github-repo');
  return response.data;
};

export const setRepo = async (name: string, url: string): Promise<RepoData> => {
  const response = await apiClient.put<RepoData>('/api/github-repo', { name, url });
  return response.data;
};

export const addPr = async (prNumber: number): Promise<RepoData> => {
  const response = await apiClient.post<RepoData>('/api/github-repo/prs', { prNumber });
  return response.data;
};

export const removePr = async (prId: string): Promise<void> => {
  await apiClient.delete(`/api/github-repo/prs/${encodeURIComponent(prId)}`);
};

export const fetchOpenPrs = async (author: string): Promise<RepoData> => {
  const response = await apiClient.get<RepoData>(
    `/api/github-repo/prs/fetch-open?author=${encodeURIComponent(author)}`,
  );
  return response.data;
};

export const getPrStatus = async (prId: string): Promise<CommitStatus> => {
  const response = await apiClient.get<CommitStatus>(
    `/api/github-repo/prs/${encodeURIComponent(prId)}/status`,
  );
  return response.data;
};

export const rerunE2e = async (prId: string): Promise<void> => {
  await apiClient.post(`/api/github-repo/prs/${encodeURIComponent(prId)}/rerun-e2e`);
};

export const toggleAutoRerun = async (prId: string): Promise<RepoData> => {
  const response = await apiClient.patch<RepoData>(
    `/api/github-repo/prs/${encodeURIComponent(prId)}/auto-rerun`,
  );
  return response.data;
};
